/* External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { Warehouse, WarehouseStatus } from '../../types';
import { ListWarehousesAction, ListWarehousesActionTypes } from './types';

export interface ListWarehousesState {
  error?: Error;
  loading?: boolean;
  warehouses: Warehouse[];
  statuses?: WarehouseStatus[];
  total: number;
}

export const initialListWarehousesState: ListWarehousesState = {
  warehouses: [],
  statuses: [],
  loading: true,
  total: 0,
};

export default function listWarehousesReducer(state = initialListWarehousesState, action: ListWarehousesAction) {
  switch (action.type) {
    case ListWarehousesActionTypes.LIST_WAREHOUSES:
      return update(state, {
        $unset: ['error'],
        loading: { $set: true },
        statuses: { $set: action.input.filter?.statuses },
      });

    case ListWarehousesActionTypes.LIST_WAREHOUSES_SUCCESS:
      return update(state, {
        loading: { $set: false },
        warehouses: { $set: action.warehouses },
        total: { $set: action.total },
      });

    case ListWarehousesActionTypes.LIST_WAREHOUSES_ERROR:
      return update(state, {
        error: { $set: action.error },
        loading: { $set: false },
      });

    case ListWarehousesActionTypes.LIST_WAREHOUSES_RESET_ERROR:
      return update(state, { $unset: ['error'] });

    case ListWarehousesActionTypes.LIST_WAREHOUSES_RESET_STATE:
      return initialListWarehousesState;

    default:
      return state;
  }
}
